import {
  Directive,
  ElementRef,
  Input,
  NgModule, OnDestroy, OnInit,
  Renderer2,
} from '@angular/core';
import { DatePipe } from "@angular/common";
import { Subject } from 'rxjs';
@Directive({
  selector: "[appCustomDate]",
})
export class CustomDateDirective implements OnInit,OnDestroy {
  @Input() appCustomDate: any;
  private destroy$ = new Subject<void>();
  constructor(private el: ElementRef, private datepipe: DatePipe) {}

  ngOnInit(): void {
    if (this.appCustomDate && this.appCustomDate.date) {      
      const inputDate = new Date(this.appCustomDate.date);
      const today = new Date();
      const yesterday = new Date(today);
      yesterday.setDate(yesterday.getDate() - 1);
      if (inputDate.setHours(0, 0, 0, 0) == today.setHours(0, 0, 0, 0)) {
        this.el.nativeElement.textContent = "Today";
      } else if (
        inputDate.setHours(0, 0, 0, 0) == yesterday.setHours(0, 0, 0, 0)
      ) {
        this.el.nativeElement.textContent = "Yesterday";
      } else {
        const latestDate = this.datepipe?.transform(this.appCustomDate.date, this.appCustomDate.dateFormat);
        this.el.nativeElement.textContent = latestDate;
      }
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

}
@NgModule({
  declarations: [CustomDateDirective],
  exports: [CustomDateDirective],
  providers: [DatePipe],
})
export class CustomDateDirectiveModule {}
